<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn class="mr-1" small color="primary" dark v-on="{...tooltip}"
                    v-on:click="()=>dialog=!dialog"
                >
                    <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
            </template>
            <span>{{$t('referenceBooks.users.ChangeBranch')}}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
        >
            <v-card width="800">
                <v-card-title>
                    <span class="headline">{{$t('referenceBooks.users.ChangeBranch')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.banks.Name')}} : {{user.bankName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.branches.Name')}} : {{user.branchName}}
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                        clearable
                                        :label="$t('Branches')"
                                        :items="branchesExceptCurrentBranch"
                                        v-model="selectedBranch"
                                        :item-value="'branchId'"
                                        :item-text="'name'"
                                        :key="'branchId'"
                                        return-object
                                />

                            </v-col>

                        </v-row>
                    </v-container>
                    <v-row v-if="actionPerformed">
                        <ActionResult :success="success"/>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('Close')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('Save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import ActionResult from '@/components/ActionResult';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  name: 'PinUserToAnotherBranch',
  components: {ActionResult, DragForm},
  props: {
    user: {
      type: Object
    },

  },
  data() {
    return {
      actionPerformed: false,
      success: false,
      error: false,
      dialog: false,
      selectedBranch: null,
      branches: []
    };
  },
  computed: {
    branchesExceptCurrentBranch(){
      return this.branches;
    }
  },
  async mounted(){
    await this.$axios.branches.getByBanksArrayForUsersPage([this.user.bankId])
      .then(response => response.data)
      .then(json => this.branches = json)
      .catch(error => console.error(error));

    if (this.user.branchId !== null){
      this.selectedBranch = {branchId: this.user.branchId, name: this.user.branchName};
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    async save() {
      let data = [];
      if (this.selectedBranch){
        data = [this.selectedBranch.branchId];
      }

      await this.$axios
        .users.changeBranch(
          this.user.userId,
          data
        )
        .then(() => {
          if (data.length){
            notifySuccess('', this.$t('Messages.UserWasPinnedToAnotherBranch', [this.user.name, this.selectedBranch.name]));
          }
          else {
            notifySuccess('', this.$t('Messages.UserWasUnpinnedFromBranch', [this.user.name, this.user.branchName]));
          }
          this.$emit('attach', this.user.userId);
          this.close();
        })
        .catch(error => {
          notifyError('', this.$t('Error'));
          console.error(error);
          this.$emit('error', error);
        });

    },

  },

};
</script>